var _rect, _rect2, _rect3, _path, _path2, _line, _line2, _line3, _line4, _path3, _line5, _line6, _path4, _path5, _path6, _path7, _rect4, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInspectionLists(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.05957,
    width: 10.854,
    height: 14.5973,
    rx: 0.5,
    fill: "white",
    stroke: "#A3A3A3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.49609,
    y: 1.93604,
    width: 6.86283,
    height: 1.87168,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.58901,
    y: 2.40396,
    width: 4.6792,
    height: 0.935841,
    rx: 0.46792,
    fill: "white",
    stroke: "#A3A3A3",
    strokeWidth: 0.935841
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92664 1C5.17797 1 5.19877 1.83186 5.30275 2.24779H6.55049C6.65449 1.83186 6.67532 1 5.92664 1Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 6.45858L2.49889 6.9265L3.74668 5.67871",
    stroke: "#A3A3A3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.37109,
    y1: 5.80273,
    x2: 9.98614,
    y2: 5.80273,
    stroke: "#A3A3A3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.37109,
    y1: 7.05029,
    x2: 9.98614,
    y2: 7.05029,
    stroke: "#A3A3A3"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.36719,
    y1: 9.54639,
    x2: 9.98223,
    y2: 9.54639,
    stroke: "#A3A3A3"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 4.36719,
    y1: 10.7939,
    x2: 9.98223,
    y2: 10.7939,
    stroke: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 13.9459L2.49889 14.4138L3.74668 13.166",
    stroke: "#A3A3A3"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 4.37109,
    y1: 13.29,
    x2: 9.98614,
    y2: 13.29,
    stroke: "#A3A3A3"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 4.37109,
    y1: 14.5376,
    x2: 9.98614,
    y2: 14.5376,
    stroke: "#A3A3A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.01563 9.76025L3.52941 11.2741",
    stroke: "#A3A3A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.01562 11.2739L3.52946 9.7601",
    stroke: "#A3A3A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.389 7.7405C13.7778 7.27797 14.468 7.21821 14.9305 7.60702C15.393 7.99583 15.4528 8.68598 15.064 9.14851L13.0998 11.4851L11.4248 10.0771L13.389 7.7405Z",
    fill: "white",
    stroke: "#A3A3A3",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04591 16.0109C8.9621 16.1106 8.85768 16.191 8.73984 16.2465C8.04298 16.5748 7.28181 15.9349 7.48542 15.192C7.51985 15.0664 7.58108 14.9497 7.6649 14.85L8.26153 14.1402L9.64255 15.3011L9.04591 16.0109Z",
    fill: "white",
    stroke: "#A3A3A3",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2493,
    y: 10.5827,
    width: 1.80414,
    height: 4.50401,
    transform: "rotate(40.051 11.2493 10.5827)",
    fill: "white",
    stroke: "#A3A3A3",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73047 16.1709L7.27048 16.7181",
    stroke: "#A3A3A3",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2817 8.9777C15.4457 8.88209 15.5705 8.75352 15.8057 8.95121C16.0408 9.14889 15.8923 9.44501 15.7546 9.60872C15.5246 9.88232 15.0327 10.1692 14.5727 10.7164C14.266 11.0812 13.8265 11.7234 14.0617 11.9211C14.2968 12.1188 14.509 11.9858 14.5856 11.8946",
    stroke: "#A3A3A3",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectionLists);
export default __webpack_public_path__ + "static/media/inspection-lists.cdf492b8d3e4fe7aca68d7d17dca2aff.svg";
export { ForwardRef as ReactComponent };